enum WinnerStatus {
  Left = "W : L",
  Right = "L : W",
  Draw = "D : D",
}

export default WinnerStatus;
